import UserNumero from '@/generated/controls/user/UserNumero.vue';
import { defineComponent } from "vue";
import validator, { rules, RULES_FRENCH_LABEL } from '@/generated/validators/ValidationRules';

export default defineComponent({ components: {},
    extends: UserNumero,
    props: {
        mobileOnly: { type: Boolean, default: false }
    },
    methods: {
        focusValidator(_value: string): validator | null {
            return this.mobileOnly
                ? new validator(rules.numeroMobileValid, RULES_FRENCH_LABEL.text.numeroMobileValid.error)
                : new validator(rules.numeroValid, RULES_FRENCH_LABEL.text.numeroValid.error);
        }
    }
})
